import React, { useEffect, useState } from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import InterestsIcon from "@mui/icons-material/Interests";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import productsJson from "../../components/jsonData";

const ProductDetail = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { id } = useParams();
  console.log(id);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = React.useState(null); // For the modal
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // const response = await axios.get(`${apiUrl}getProductById/${id}`, {
        //   timeout: 10000,
        // });
        // if (response.status === 200) {
        //   setProduct(response.data);
        // } else {
        //   toast.error("Failed to fetch product details");
        //   setError("Failed to fetch product details");
        // }

        const productFound = productsJson.find((item) => item._id === id);
        if (productFound) {
          setProduct(productFound);
        } else {
          setError("Product not found");
        }
      } catch (error) {
        // if (error.code === "ECONNABORTED") {
        //   // Handle request timeout
        //   toast.error("Server timed out. Please try again.");
        //   setError("Server timed out. Please try again.");
        // } else if (error.response) {
        //   // Server responded with a status code outside the range of 2xx

        //   toast.error(
        //     "Error fetching product details. Please try again later."
        //   );
        // } else if (error.request) {
        //   toast.error(
        //     "No response from the server. Please check your connection."
        //   );
        //   setError(
        //     "Unable to connect to the server. Please check your connection."
        //   );
        // } else {
        //   toast.error("An unexpected error occurred. Please try again.");
        //   setError("An unexpected error occurred. Please try again.");
        // }

        setError("Error fetching product details");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  useEffect(() => {
    if (product && product.images.length > 0) {
      Fancybox.bind("[data-fancybox='gallery']", {
        infinite: false,
      });
    }
  }, [product]);

  const formatProductTitle = (title, id) => {
    const formattedTitle = title.split(" ").join("-");
    return `/productDetail/${formattedTitle}/${id}`;
  };
  const checkIfLoggedIn = () => {
    return localStorage.getItem("Fttoken") !== null;
  };

  const handleShowInterestClick = (product) => {
    if (!checkIfLoggedIn()) {
      toast.warn(
        "You need to be logged in to show interest, It will automatically redirect to the login page."
      );
      setTimeout(() => {
        navigate("/login");
      }, 3000);
      return;
    }
    setSelectedProduct(product); // Set the product for the modal
    setIsModalOpen(true); // Open modal
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setComment("");
  };

  const handleCommentSubmit = async () => {
    const userId = localStorage.getItem("FtIdUser");
    const productId = selectedProduct._id;
    const prdcomment = comment;
    if (!userId) {
      toast.warn("You need to be logged in to submit interest.");
      return;
    }

    const interestData = {
      productId: productId,
      userId: userId,
      comment: prdcomment,
    };

    try {
      const response = await axios.post(`${apiUrl}/addInterest`, interestData);

      if (response.status === 200) {
        toast.success("Interest submitted successfully!");
        handleModalClose();
        setSelectedProduct(null);
        setComment("");
      } else {
        toast.error(`Failed to submit interest. Status: ${response.status}`);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };
  return (
    <div>
      <Navbar />
      <ToastContainer />
      <div className="page-header bg-[#F8F8F8] ">
        <div className="container">
          <h1 className="font-bold text-xl mb-3 text-[#003245]">
            {product?.title || "No Title Found!"}
          </h1>
          <ul className="flex gap-2">
            <Link to="/productlists" className="text-sm text-[#003245]">
              Products
            </Link>
            <ChevronRightIcon sx={{ fontSize: "19px" }} />
            <Link to="/" className="text-sm text-[#003245]">
              Product Detail
            </Link>
          </ul>
        </div>
      </div>

      <div className="pt-[4rem] pb-[4rem]">
        {loading ? (
          <p className="text-sm p-10">Loading product details...</p>
        ) : error ? (
          <div className="error-message container">
            <p className="text-red-600 p-10 text-sm bg-red-100 rounded-md">
              {error}
            </p>
          </div>
        ) : product ? (
          <div className="detail-upper-col">
            <div className="product-detail-wrap container">
              <div className="product-images">
                {product.images.map((image, index) => (
                  <a
                    key={index}
                    data-fancybox="gallery"
                    href={image}
                    data-caption={product.title}
                    className={
                      index === 0 ? "product-big" : "product-thumbnail"
                    }
                  >
                    <img
                      src={image}
                      alt={product.title}
                      className={
                        index === 0
                          ? "product-big-img"
                          : "product-thumbnail-img"
                      }
                    />
                  </a>
                ))}
              </div>

              <div className="product-detail-content">
                {product.prdCategory === "Buy" ? (
                  <span className="pCtg-green">For Sale</span>
                ) : (
                  <span className="pCtg-red">For Rent</span>
                )}
                <h1>{product.title}</h1>
                <p>{product.shortDescription}</p>

                <div className="mt-8 interest-box-dtl">
                  <p>Get more info about availability, price and delivery</p>
                  <button
                    className="btn-interest btn-list btn-interest-lg"
                    onClick={() => handleShowInterestClick(product)}
                  >
                    Show Interest
                    <InterestsIcon
                      sx={{ fontSize: "22px", marginLeft: "15px" }}
                    />
                  </button>
                </div>

                <div className="dtl-spec">
                  <span className="dtl-title">Reference No. :</span>
                  <span className="dtl-tag">
                    {product.ref_number || "----"}
                  </span>
                </div>

                <div className="dtl-spec">
                  <span className="dtl-title">Product Model:</span>
                  <span className="dtl-tag">{product.prdModel}</span>
                </div>

                <div className="dtl-spec">
                  <span class="dtl-title">Share with Us:</span>
                  <span className="dtl-share">
                    <a
                      href={`https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20this%20product. ${baseUrl}${formatProductTitle(
                        product.title,
                        product._id
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsappIconDtl"
                    >
                      <WhatsAppIcon
                        sx={{
                          fontSize: "20px",
                          color: "#fff",
                        }}
                      />
                    </a>
                    <a
                      href={`mailto:info@agacrane.com?subject=Need%20information%20about%20this%20product. ${baseUrl}${formatProductTitle(
                        product.title,
                        product._id
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mailIconDtl"
                    >
                      <MailOutlineIcon
                        sx={{
                          fontSize: "20px",
                          color: "#DA4B3E",
                        }}
                      />
                    </a>
                    <a
                      href="tel:971501501145"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mailIconDtl"
                    >
                      <SmartphoneIcon
                        sx={{
                          fontSize: "20px",
                          color: "#DA4B3E",
                        }}
                      />
                    </a>
                  </span>
                </div>
              </div>
            </div>

            <section className="section-product pt-[4rem] pb-[4rem] mt-[6rem]">
              <div className="container">
                <div className="flex-hdng">
                  <div>
                    <h1 className="heading1">View Detail Specification</h1>
                  </div>
                </div>

                <div className="product-specification">
                  <div className="spec-item">
                    <div className="spec-title">Product Type:</div>
                    <div className="spec-value">{product.prdType}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Product Condition:</div>
                    <div className="spec-value">{product.prdCondition}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Reference Number:</div>
                    <div className="spec-value">{product.ref_number}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Operating Weight:</div>
                    <div className="spec-value">{product.opr_weight} KGs</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Manufacture By:</div>
                    <div className="spec-value">{product.manufacture}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Model:</div>
                    <div className="spec-value">{product.prdModel}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Stock:</div>
                    <div className="spec-value">{product.prdStock}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Product Brand:</div>
                    <div className="spec-value">
                      {product.prdBrand ? product.prdBrand : "----"}
                    </div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Product Location:</div>
                    <div className="spec-value">
                      {product.prdLocation ? product.prdLocation : "----"}
                    </div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Estimated Delivery Time:</div>
                    <div className="spec-value">
                      {product.prdDelivery ? product.prdDelivery : "----"}
                    </div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Year of Manufacture:</div>
                    <div className="spec-value">{product.prdYear}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Product Color:</div>
                    <div className="spec-value">{product.productColor}</div>
                  </div>

                  <div className="spec-item">
                    <div className="spec-title">Description:</div>
                    <div className="spec-value">{product.longDescription}</div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <p className="text-sm">Product not found</p>
        )}
      </div>
      <Footer />

      {/* Modal for Show Interest */}
      <Dialog
        open={isModalOpen}
        onClose={handleModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Review Product and Send to Us."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedProduct && (
              <>
                <div className="product-modal-wrap">
                  <div>
                    <img
                      src={selectedProduct.images[0] || "default-image.jpg"}
                      alt={selectedProduct.title}
                    />
                  </div>
                  <div className="product-info relative">
                    {selectedProduct.prdCategory === "Buy" ? (
                      <span className="pCtg-green abosl">For Sale</span>
                    ) : (
                      <span className="pCtg-red abosl">For Rent</span>
                    )}
                    <h2>{selectedProduct.title}</h2>
                    <div className="specs-wrap">
                      <div className="specs">
                        <p>Model:</p>
                        <span>{`${selectedProduct.prdModel}`}</span>
                      </div>

                      <div className="specs">
                        <p>Operating Weight:</p>
                        <span>{`${selectedProduct.opr_weight} KGs`}</span>
                      </div>

                      <div className="specs">
                        <p>Brand:</p>
                        {selectedProduct.prdBrand ? (
                          <span>{selectedProduct.prdBrand}</span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group mb-5 mt-5">
                  <label className="text-sm mb-2 pl-1 block font-medium">
                    Your Comments
                  </label>
                  <textarea
                    rows={4}
                    className="form-control"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    name="comment"
                  ></textarea>
                </div>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCommentSubmit} autoFocus className="modalBTN">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProductDetail;
